import api from '@/services/api';

const UrlQuery = {
  checkUrlValue: url => {
    return api.post('check_url/', {
      url: url
    });
  }
};
export default UrlQuery;



// WEBPACK FOOTER //
// ./src/api/url/query.js